import React, {Component} from 'react';
import styles from './IntegrationsSection.scss';
import classNames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react'
import ScrollMagic from "scrollmagic";
import integrationsEcho from 'assets/images/awair/integrations-echo.png';
import integrationsNest from 'assets/images/awair/integrations-nest.png';
import integrationsWemo from 'assets/images/awair/integrations-wemo.png';

const cx = classNames.bind(styles);

class IntegrationsStore {
  @observable animationsOn = false;

  @action activeAnimationsOn = () => this.animationsOn = true;
  @action unactiveAnimationsOn = () => this.animationsOn = false;
}

const integrationsStore = new IntegrationsStore();

@observer
class IntegrationsSection extends Component {
  integrationsSectionRef;

  handleSceneAnimation = () => {
    const {integrationsSectionRef} = this;
    const {activeAnimationsOn, unactiveAnimationsOn} = integrationsStore;

    const integrationsController = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: integrationsSectionRef,
      triggerHook: 'onEnter',
      duration: window.innerHeight + 1650,
      offset: 0
    })
      .on('enter', () => {
        activeAnimationsOn();
      })
      .on('leave', () => {
        unactiveAnimationsOn();
      })
      .addTo(integrationsController);
  };

  componentDidMount() {
    this.handleSceneAnimation();
  }

  render() {
    const {animationsOn} = integrationsStore;

    return (
      <section className={cx('integrations', animationsOn && 'animations-on')} ref={ref => this.integrationsSectionRef = ref}>
        <div className={cx('device', 'echo')}>
          <div className={cx('ring', 'echo-ring-1')} />
          <div className={cx('ring', 'echo-ring-2')} />
          <img src={integrationsEcho} alt='echo' />
        </div>
        <div className={cx('device', 'nest')}>
          <div className={cx('ring', 'nest-ring-1')} />
          <div className={cx('ring', 'nest-ring-2')} />
          <img src={integrationsNest} alt='nest' />
        </div>
        <div className={cx('device', 'wemo')}>
          <div className={cx('ring', 'wemo-ring-1')} />
          <div className={cx('ring', 'wemo-ring-2')} />
          <img src={integrationsWemo} alt='wemo' />
        </div>
        <div className={cx('integrations-intro')}>
          <h2 lang='en-regular'>Breathe Easy</h2>
          <p><span lang='en-thin'>Awair</span>は自動的に快適で健康的な空気を維持できるよう、他のスマート機器と連動します。</p>
        </div>
      </section>
    );
  }
}

export default IntegrationsSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/IntegrationsSection/IntegrationsSection.js